import React, { FC } from "react";

import { useFormContext } from "react-hook-form";

import { StepComponentProps } from "@/components/organisms";

import { CustomerCardFormType } from "../../formType";
import MoralDetails from "./MoralDetails/MoralDetails";
import PhysicalDetails from "./PhysicalDetails/PhysicalDetails";

const DetailsStep: FC<StepComponentProps> = () => {
    const { getValues } = useFormContext<CustomerCardFormType>();
    const isPhysicalPerson = getValues("isPhysicalPerson");
    return isPhysicalPerson ? <PhysicalDetails /> : <MoralDetails />;
};

export default DetailsStep;
